import {useSearchParams} from "react-router-dom";
import {ProductCollectionComponent} from "./ProductCollectionComponent";
import React from "react";

export default function ProductListProvider(
) {
    const [searchParams, setSearchParams] = useSearchParams();

    const searchTerm=searchParams.get('id');
    const cat=searchParams.get('cat');

    console.log(searchTerm,cat)

    return <ProductCollectionComponent id={searchTerm}/>
}
